import { PageViewEventLogger } from '@repo/tracking-service';
import { AuthGuard } from '@repo/user-session';

import Layout from '@/components/layout/Layout';
import { useRightInquiryTextButton } from '@/components/tax-refund/common/hooks/use-create-header-props';
import DecisionSelectAuthContent from '@/components/tax-refund/individual/DecisionRefund/SelectAuth/DecisionSelectAuthContent';
import { SUPPORT_BOT_LINK } from '@/lib/constants/link';

const DecisionSelectAuthPage = () => {
  const rightInquiryButton = useRightInquiryTextButton(SUPPORT_BOT_LINK.인증타입선택, 'indis-decision_selectauth_cx');

  return (
    <AuthGuard>
      <PageViewEventLogger pageName={'indis-decision'} eventName={'indis-decision_selectauth'}>
        <Layout leftIcon={{ icon: 'back', clickEvent: { name: 'indis-decision_topnav_back' } }} rightTextButton={rightInquiryButton}>
          <DecisionSelectAuthContent />
        </Layout>
      </PageViewEventLogger>
    </AuthGuard>
  );
};

export default DecisionSelectAuthPage;
